import React,{useState} from 'react';
import Table from 'react-bootstrap/Table';
import {dateFormat} from "../../utils";
import { Dialog } from 'primereact/dialog';
//import moment from 'moment';
import Pagination from 'react-responsive-pagination';
import moment from 'moment-timezone';
import { useNavigate } from "react-router-dom";
//import Swal from '../../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../../messageBox/customSweetAlert';
import CheckListModal from '../ModalContent/CheckListModal';
import axios from 'axios';
import {ADD_CHECK_LIST,UPDATE_CHECK_LIST,EDIT_CHECKLIST_VALUE} from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
function CheckListTable({tableData}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isModalVisible, setModalVisible] = useState(false);
    const [checkListDetails,setCheckListDetails] = useState('');
    //const [loading, setLoading] = useState(false); // Loading state
    const [isEdit, setIsEdit] = useState(true);
    const [error, setError] = useState(false);
    const [updatedId, setUpdatedId] = useState('');

       const openModal = (isEditMode = true, initialValue = '') => {
        setIsEdit(isEditMode);
        setCheckListDetails(initialValue);
        setModalVisible(true);
    };
    
    const closeModal = () => {
        setModalVisible(false);
        setError(false); // Reset error state when modal is closed
    };
    const handleEditClick=(id)=>{
        dispatch(setLoading(true));
        setUpdatedId(id);
        axios.get(EDIT_CHECKLIST_VALUE + '/' + `${id}`)
        .then(response => {
            console.log(response.data.data.check_list); // Accessing the data here
            if (response.data) {
                dispatch(setLoading(false));
                openModal(true, response.data.data.check_list);
            }
        })
        .catch(error => {
            console.error("There was an error fetching the data!", error);
        });
        
       }
    const handleInputChange = (e) => {
        const { value } = e.target;
        setCheckListDetails(value);
    };
    
    const checkListForm =async(e)=>{
        //e.preventDefault();
        setError(false); // Reset error state on form submission
        //setLoading(true);
       
        try {
            dispatch(setLoading(true));
            if(checkListDetails){
                const response = isEdit 
                ? await axios.post(`${UPDATE_CHECK_LIST}/${updatedId}`,{ check_list: checkListDetails }) // Assuming you have an ID for update
                : await axios.post(ADD_CHECK_LIST, { check_list: checkListDetails });
            //return false;
            //console.log(response.data.status);
            if (response.data.status === '200') {
                dispatch(setLoading(false));
                setModalVisible(false);
                navigate('/home/checking/list', { replace: true });
                Swal.fire({
                  title: 'Success!',
                  text: response.data.message,
                  icon: 'success',
                  confirmButtonText: 'OK',
                });
            } else {
                dispatch(setLoading(false));
                setModalVisible(false);
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message,
                    icon: 'Error',
                    confirmButtonText: 'OK',
                  });
                //console.log(response.data.message);
            }
        }else{
            dispatch(setLoading(false));
            setError(true);
        }
        } catch (error) {
            dispatch(setLoading(false));
            console.error("Error logging in:", error);
        }
    }

  return (
    <><Table striped bordered hover className='tbl-require'>
          <thead>
              <tr>
                  <th>#</th>
                  <th>Check List</th>
                  <th style={{ textAlign: 'center' }}>Action</th>
              </tr>
          </thead>
          <tbody>
              {tableData && tableData.map((details, index) => (
                  <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{details.check_list}</td>

                      <td style={{ textAlign: 'center', cursor: 'pointer' }}>
                          <i className="pi pi-pen-to-square icon-btn-edit" onClick={() => handleEditClick(details.id)}></i>
                      </td>
                  </tr>
              ))}
          </tbody>
      </Table>
      <CheckListModal
                visible={isModalVisible}
                onHide={closeModal}
                title={isEdit ? "Edit Check List" : "Add Check List"}
                inputValue={checkListDetails}
                onInputChange={handleInputChange}
                onSave={checkListForm}
                isEdit={isEdit}
            /></>
  )
}

export default CheckListTable